import { forwardRef, type HTMLAttributes, type PropsWithChildren } from "react";

import {
  hubTableScrollRegionClassName,
  hubWorkspaceBodyClassName,
  hubWorkspaceHeaderClassName,
  hubWorkspacePageClassName,
  hubWorkspacePanelClassName,
  type HubWorkspacePanelScroll,
} from "@/lib/hubLayoutClassNames";
import { cn } from "@/lib/utils";

export function HubWorkspacePage({
  className,
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      data-hub-workspace-page=""
      className={cn(hubWorkspacePageClassName(), className)}
      {...rest}
    >
      {children}
    </div>
  );
}

export function HubWorkspaceHeader({
  className,
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div className={cn(hubWorkspaceHeaderClassName(), className)} {...rest}>
      {children}
    </div>
  );
}

export function HubWorkspaceBody({
  className,
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      data-hub-workspace-body=""
      className={cn(hubWorkspaceBodyClassName(), className)}
      {...rest}
    >
      {children}
    </div>
  );
}

export function HubWorkspacePanel({
  scroll = "auto",
  className,
  children,
  ...rest
}: PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    scroll?: HubWorkspacePanelScroll;
  }
>) {
  return (
    <div
      data-hub-scroll-region=""
      className={cn(hubWorkspacePanelClassName(scroll), className)}
      {...rest}
    >
      {children}
    </div>
  );
}

export const HubTableScrollRegion = forwardRef<
  HTMLDivElement,
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
>(function HubTableScrollRegion({ className, children, ...rest }, ref) {
  return (
    <div
      ref={ref}
      data-hub-scroll-region=""
      className={cn(hubTableScrollRegionClassName(), className)}
      {...rest}
    >
      {children}
    </div>
  );
});
